import {
    GET_APPLICANT_DUPLICATION_INFO,
    DUPLICATION_LOADING,
    DUPLICATION_ERROR
} from 'actions/types';

const initialState = {
    duplicationInfo: null,
    loading: false,
    error: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_APPLICANT_DUPLICATION_INFO:
            return {
                ...state,
                duplicationInfo: action.payload,
                error: null
            };
        
        case DUPLICATION_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        
        case DUPLICATION_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        
        default:
            return state;
    }
}